import React from "react";
import { Container } from "react-bootstrap";
import mobApp from "../../../Asset/cta-ng.png";
import { useNavigate } from "react-router-dom";

const Fourth = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/ContactUs");
  };
  return (
    <>
      <section
        className="sixth-mobileApp-section"
        style={{ backgroundColor: "var( --white-color)" }}
      >
        <Container>
          <div
            className="mob-dev-cta"
            style={{ backgroundColor: "var( --light-primary-bg)" }}
          >
            <div className="row align-items-center">
              <div className="col-xl-8 col-md-8">
                <div className="sec-6-cta-card">
                  <h3>
                    Scale Smarter with
                    <strong className="text-skyblue"> Data & AI</strong>
                  </h3>
                  <a onClick={handleNavigate} className="btn btn-primary">
                    Contact Us
                  </a>
                </div>
              </div>
              <div className="col-xl-4 col-md-4">
                <div className="cta-bg">
                  <img alt="mobile" src={mobApp} className="w-100" />
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Fourth;
